import { Switch } from "@/components/ui/baseUi/switch"
import { Text } from "@/components/ui/baseUi/text"
import { cn } from "@/modules/lib/utils"
import { RpeSlider } from "@/modules/sessions/sessionForm/blocks/exerciseBlock/components/rpeSlider"
import {
  type ExerciseFormikType,
  type ExerciseInputKey,
} from "@/modules/sessions/sessionForm/blocks/exerciseBlock/exerciseFormikTypes"
import type { SimpleFormik } from "@/typings/formik"
import { word } from "@modules/core/utils/i18n"
import { useMemo } from "react"

export function ExerciseRpeInput({
  formik,
  className,
  ...props
}: { formik: SimpleFormik<ExerciseFormikType, ExerciseInputKey> } & React.ComponentProps<"div">) {
  const isRpeActive = useMemo(() => {
    if (formik.values.rpe !== null) {
      return true
    } else {
      return false
    }
  }, [formik.values.rpe])

  const onRpe = () => {
    if (isRpeActive) {
      formik.setFieldValue("rpe", null)
    } else {
      formik.setFieldValue("rpe", 5)
    }
  }
  return (
    <div className={cn("h-70 flex-1 rounded-2xl bg-surface-foreground px-5 py-6", className)} {...props}>
      <div className="mb-2 flex w-full justify-between">
        <Text className="my-1 font-bold text-textDefault-body" fontStyle="LL">
          {word("sessionForm.exercise.askRpe")}
        </Text>
        <Switch checked={isRpeActive} onCheckedChange={onRpe} />
      </div>
      <Text className="text-textDefault-body" fontStyle="BS">
        {word("sessionForm.exercise.rpe.description")}
      </Text>
      <RpeSlider
        isRpe={isRpeActive}
        value={formik.values.rpe}
        setValue={(value: number | null) => {
          void formik.setFieldValue("rpe", value)
        }}
      />
    </div>
  )
}
